import React, { useEffect, useState } from 'react'
import { Bounce, ToastContainer } from 'react-toastify'
import style from '../styles/Cabinet/Cabinet.module.css';
import { getLogos } from 'src/redux/reducers/imagesReduser';
import { useDispatch } from 'react-redux';
import { RootState } from 'src/interface/IRootState';
import { useSelector } from 'react-redux';
import { Tab, Tabs } from '@mui/material';
import HomePage from './CabinetElements/HomePage';
import OrdersPage from './CabinetElements/OrdersPage';
import FaqPage from './CabinetElements/FaqPage';
import useUserData from 'src/hooks/useUserData';


const Cabinet: React.FC = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [loading] = useUserData();

  useEffect(() => {
    dispatch(getLogos(['p2pLogo']));
  }, [dispatch]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClickLogo = () => {
    setValue(0);
  }

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  const selectedLogos = useSelector((state: RootState) => state.images);

  return (
    <div className={style.container}>
      <div className={style.header}>
        <div className={style.containerLogo} onClick={handleClickLogo}>
          <img src={selectedLogos.p2pLogo} alt='P2P Logo' style={{ cursor: 'pointer' }} />
        </div>

        <div className={style.navbar}>
          <Tabs value={value} onChange={handleChange} aria-label="navigation button">
            <Tab label="Home" {...a11yProps(0)} sx={{ marginX: { xs: 1, sm: 2, md: 3, lg: 5 } }} />
            <Tab label="Orders" {...a11yProps(1)} sx={{ marginX: { xs: 1, sm: 2, md: 3, lg: 5 } }} />
            <Tab label="FAQ" {...a11yProps(2)} sx={{ marginX: { xs: 1, sm: 2, md: 3, lg: 5 } }} />
          </Tabs>
        </div>

        <div className={style.voidHeaderBox} />
      </div>

      {value === 0 && <HomePage loading={loading} />}
      {value === 1 && <OrdersPage loading={loading}/>}
      {value === 2 && <FaqPage />}

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  )
}

export default Cabinet